import Login from './voim/bypassing';

export const screen = {
    login: 'bypassing', // if you want to change the screen to login, need to change it as "login."
};

export const screens = [
    {
        screen: screen.login,
        whiteLabeled: true,
        component: Login,
    },
];
